import { render, staticRenderFns } from "./PublishArticle.vue?vue&type=template&id=5eb66924&scoped=true"
import script from "./PublishArticle.vue?vue&type=script&lang=js"
export * from "./PublishArticle.vue?vue&type=script&lang=js"
import style0 from "./PublishArticle.vue?vue&type=style&index=0&id=5eb66924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb66924",
  null
  
)

export default component.exports